import {
  TSecondaryMenuItem,
  TSelectionMenu,
} from '@components/common/Navbar/Navbar.types'
import { Entry } from 'contentful'
import {
  INavbarDropdown,
  TContentfulSelectionMenu,
} from 'types/contentful/navbarDropdown'
import { mapContentfulImageAsset } from '../contentfulImage'

function mapSelectionMenu(
  selectionMenus: TContentfulSelectionMenu[]
): TSelectionMenu[] {
  return (
    selectionMenus?.map((selectionMenu) => ({
      selectionMenuTitle: selectionMenu?.fields?.ctaLabel || null,
      selectionMenuLink: selectionMenu?.fields?.ctaLink || null,
      selectionMenuItems:
        selectionMenu?.fields?.primaryReferences?.map((selectionMenuItem) => ({
          label: selectionMenuItem?.fields?.ctaLabel || null,
          link: selectionMenuItem?.fields?.ctaLink || null,
        })) || null,
    })) || null
  )
}

export function mapSecondaryMenuItems(
  secondaryMenuItems: Entry<INavbarDropdown>[]
): TSecondaryMenuItem[] {
  const mappedSecondaryMenuitems = secondaryMenuItems?.map(
    (secondaryMenuItem) => {
      return {
        type: secondaryMenuItem?.fields?.type || 'list-dropdown',
        title: secondaryMenuItem?.fields?.title?.fields?.ctaLabel || null,
        titleLinkUrl: secondaryMenuItem?.fields?.title?.fields?.ctaLink || null,
        content: {
          title: secondaryMenuItem?.fields?.content?.fields?.h1 || null,
          description: secondaryMenuItem?.fields?.content?.fields?.h2 || null,
          ctaLabel:
            secondaryMenuItem?.fields?.content?.fields?.ctaLabel || null,
          ctaLink: secondaryMenuItem?.fields?.content?.fields?.ctaLink || null,
        },
        selectionMenus:
          mapSelectionMenu(secondaryMenuItem?.fields?.selectionMenuItems) ||
          null,
        startWithTiles: secondaryMenuItem?.fields?.startWithTiles || null,
        tiles:
          secondaryMenuItem?.fields?.tiles?.map((tile) => ({
            title: tile?.fields?.title || null,
            titleSize: tile?.fields?.titleSize || null,
            titleColor: tile?.fields?.titleColor || null,
            subtitle: tile?.fields?.subtitle || null,
            subtitleColor: tile?.fields?.subtitleColor || null,
            image: mapContentfulImageAsset(tile?.fields?.image) || null,
            images:
              tile?.fields?.images?.map((x) => mapContentfulImageAsset(x)) ||
              null,
            backgroundColor: tile?.fields?.backgroundColor || null,
            blockLink: tile?.fields?.blockLink || null,
            desktopLayout: tile?.fields?.desktopLayout || 'regular',
            mobileLayout: tile?.fields?.mobileLayout || 'regular',
          })) || null,
        tileSectionLink: {
          title:
            secondaryMenuItem?.fields?.tileSectionLink?.fields?.ctaLabel ||
            null,
          link:
            secondaryMenuItem?.fields?.tileSectionLink?.fields?.ctaLink || null,
        },
      }
    }
  )
  return mappedSecondaryMenuitems || null
}
